import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Archive, Building2, Calendar, Clock, Eye } from "lucide-react";
import { RelationsMonitor } from "@/components/office/RelationsMonitor";

function fmtDate(s) {
  if (!s) return "—";
  const d = new Date(s.length <= 10 ? `${s}T00:00:00` : s);
  return isNaN(d) ? s : d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
}

export function RelationsArchive() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [monitorId, setMonitorId] = useState(null);

  const load = () => {
    setLoading(true);
    api.get("/office/relations/templates?archived=true").then((r) => setItems(r.data || [])).catch(() => setItems([])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  if (monitorId) {
    return <RelationsMonitor templateId={monitorId} onClose={() => setMonitorId(null)} />;
  }

  return (
    <div className="space-y-4" data-testid="relations-archive">
      <p className="text-sm text-slate-500">Relazioni archiviate</p>
      {loading ? (
        <p className="text-sm text-slate-500 p-4">Caricamento…</p>
      ) : items.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-10 text-center" data-testid="relations-archive-empty">
          <Archive className="h-8 w-8 text-slate-300 mx-auto mb-3" />
          <p className="text-sm text-slate-500">Nessuna relazione archiviata.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {items.map((it) => (
            <div key={it.id} className="rounded-xl border border-slate-200 bg-white shadow-sm p-4 flex flex-col" data-testid={`archive-card-${it.id}`}>
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-heading font-bold text-slate-900 leading-tight">{it.title}</h3>
                <span className="shrink-0 inline-flex items-center rounded-full bg-slate-100 border border-slate-200 px-2 py-0.5 text-xs font-semibold text-slate-500">Archiviata</span>
              </div>
              <div className="mt-2 space-y-1 text-xs text-slate-500">
                <p className="flex items-center gap-1.5"><Building2 className="h-3.5 w-3.5" /> {it.appalto_nome} · {it.service_label}</p>
                {it.period_ref && <p className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {it.period_ref}</p>}
                <p className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" /> Pubblicata: {fmtDate(it.published_at)}</p>
                <p className="flex items-center gap-1.5"><Archive className="h-3.5 w-3.5" /> Archiviata: {fmtDate(it.archived_at)}</p>
              </div>
              <div className="mt-3 pt-3 border-t border-slate-100">
                <Button size="sm" variant="outline" onClick={() => setMonitorId(it.id)} data-testid={`archive-open-${it.id}`}><Eye className="h-3.5 w-3.5 mr-1" /> Consulta</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default RelationsArchive;
